import useConfig from '@tcs/create-account/hooks/useConfig';
import { queryClient } from '@tcs/create-account/hooks/useQuery';
import { ReactNode } from 'react';
import { QueryClientProvider as _QueryClientProvider } from 'react-query';
import ConfigProvider from './ConfigProvider';

const QueryClientProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const config = useConfig();

  if (config.loading) {
    return null;
  }

  const host =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:7071'
      : config.REACT_APP_BASE_PATH;

  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <_QueryClientProvider client={queryClient(host)}>
      {children}
    </_QueryClientProvider>
  );
};

const Providers: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ConfigProvider>
      <QueryClientProvider>{children}</QueryClientProvider>
    </ConfigProvider>
  );
};

export default Providers;
